
export function guessTitle(node) {
  const header = node.querySelector('h1, h2, h3, h4, h5, h6');
  if (header) return header.textContent.trim();

  const paragraph = node.querySelector('p');
  if (paragraph) {
    const words = paragraph.textContent.trim().split(/\s+/).slice(0, 5);
    return words.join(' ');
  }

  return null
}